import { Injectable } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { from, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SCHEME_URL } from '../../../config';
import { ConnectService } from '../connect/connect.service';
import { FingerPrintService } from '../finger-print/finger-print.service';
import { MixpanelAnalyticsService } from '../mixpanel-analytics/mixpanel-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private connectService: ConnectService,
    private appVersion: AppVersion,
    private fpService: FingerPrintService,
    private mixpanel: MixpanelAnalyticsService
  ) {}

  sendLoginLink(param: object) {
    return from(this.appVersion.getPackageName()).pipe(
      catchError(() => of('')),
      switchMap(packageName => {
        const account = {
          ...param,
          platform: 'browser',
          url_schema: SCHEME_URL,
          finger_print: this.fpService.getfingerPrint(),
          package_name: packageName,
        };
        this.mixpanel.track('Login', {
          ...account,
          mixpanelCategory: 'logging_in',
          mixpanelSubCategory: 'magic_link',
          mixpanelState: 'progress',
        });
        return this.connectService.create('/accounts/magic_link', {
          account,
        });
      })
    );
  }

  verifyLogin(url: string) {
    let tenantName = '';
    let token = '';
    let id = '';
    let isParticipant = '';
    let adminLogin = '';
    const [, path, search] = url.match(/^(?:([^?]*)\?(.*))?/);
    if (path !== '/login') return throwError(() => new Error('Incorrect login url'));
    const searchParams = new URLSearchParams(search);
    tenantName = searchParams.get('tenant_name');
    token = searchParams.get('token');
    id = searchParams.get('id');
    isParticipant = searchParams.get('participant_login');
    adminLogin = searchParams.get('admin_login');
    this.connectService.setSaveURL(isParticipant === 'true');
    const account = {
      token,
      schema: tenantName,
      patient_id: id,
      finger_print: this.fpService.getfingerPrint(),
      admin_login: adminLogin,
    };
    this.mixpanel.verifyLogin(account);
    return this.connectService
      .create('/accounts/verify_login', { account })
      .pipe(map(({ token }: { token: string }) => ({ token, tenantName, isParticipant, magicLinkToken: account.token })));
  }
}
